// api/subscribeCollabPacket.ts
import { registerSubscription } from "@adornis/baseql/metadata/register.js";
import { Observable, concatWith, take } from "rxjs";
import * as yjs from "yjs";
import { CollabPacket, CollabPacketType } from "../db/CollabPacket.js";
import { getRoom } from "../server/room-store.js";
import { uint8ArrayToBase64 } from "../util.js";
var subscribeCollabPacket = registerSubscription({
  type: () => CollabPacket,
  operationName: "subscribeCollabPacket",
  resolve: (roomID) => {
    return (gqlFields) => {
      const room = getRoom(roomID);
      if (!room) {
        throw new Error(`Room ${roomID} does not exist`);
      }
      const update = uint8ArrayToBase64(yjs.encodeStateAsUpdate(room.doc));
      return new Observable((subscriber) => {
        subscriber.next(new CollabPacket({ roomID, cid: "SERVER", type: CollabPacketType.Populate, payload: update }));
        subscriber.complete();
      }).pipe(take(1), concatWith(room.subject));
    };
  },
  params: [
    {
      name: "roomID",
      type: () => String
    }
  ]
});
export {
  subscribeCollabPacket
};
